import stages from '../../constants/stages';
import { SubmitActionsGenerationContract } from '../stage-contracts';

const handleMergeResult = (currentFlowData, result) => {
  if (!result) return currentFlowData;

  if (!SubmitActionsGenerationContract.isValid(result)) {
    // eslint-disable-next-line no-console
    console.warn(
      `${String(
        stages.SUBMIT_ACTIONS_GENERATION
      )} stage: handler returned invalid contract, skipping`
    );

    return currentFlowData;
  }

  const resultActions = SubmitActionsGenerationContract.get(result);

  if (!resultActions || resultActions.length === 0) return currentFlowData;

  return {
    ...currentFlowData,
    actions: [...(currentFlowData.actions || []), ...resultActions],
  };
};

const runSubmitActionsGenerationStage = ({ state, form, flowData, onRun }) =>
  onRun({
    stage: stages.SUBMIT_ACTIONS_GENERATION,
    initialContext: {
      getFieldsValues: form.getValues,
      state: state.data,
      initialState: state.getInitialState(),
      stateDiff: state.getStateDiff(),
    },
    flowData,
    onMergeResult: handleMergeResult,
  });

export default runSubmitActionsGenerationStage;
